module.exports = __webpack_public_path__ + "media/student_budgeting_calculators/student_budget_cal_bknd-ffa5acb1.png";